import LevelABackToPreviousScreenButton from "../../buttons/levelAScreen/LevelABackToPreviousScreenButton";
import {kSystemIcons} from "../../../constants/icons";
import SystemAppScreenHeader from "../SystemAppScreenHeader";

export default function LevelAHeader({isBrevetDisplay, handleBackToPreviousScreen, processModalOpening}) {
    // Used in LevelAContent to display screen header

    // BUILD
    return (
        <div className={"w-full flex justify-start items-center space-x-[16px] p-[16px]"}>
            <LevelABackToPreviousScreenButton goBackToPreviousScreen={handleBackToPreviousScreen} />
            <SystemAppScreenHeader title={"Savoir-faire"}
                                   icon={kSystemIcons.gear}
                                   onInfoClick={processModalOpening}
                                   isBrevetDisplay={isBrevetDisplay} />
        </div>
    );
}